import { gql } from '@apollo/client';
import { LanguageFragment } from 'graphql/Language/fragments/LanguageFragment';
/**
 * @fragment FieldFragment
 * @since 1.0.0
 */
export const FieldFragment = gql `
  fragment FieldFragment on Field {
    id
    type
    name
    title
    infos
    shared
    visibility
    promote
    active
    required
    options
    value
    order
    defaultValue
    defaultValueLocked
    createdAt
    updatedAt
    useInQueryBuilder

    group {
      id
      category

      createdAt
      updatedAt
    }

    translations {
      id
      title
      infos
      createdAt
      updatedAt

      language {
        ...LanguageFragment
      }
    }
  }
  ${LanguageFragment}
`;
